module.exports = __webpack_public_path__ + "static/media/WFS.c70cbb46.svg";